<template>
  <SliderModalItem v-for="typeFilter in typeFilters" :key="typeFilter['id']">
    <SliderModalContainer
      :modal-title="typeFilter['name']"
      modal-header-animation="teleport"
      modal-close-btn-icon="chevron"
      :modal-clear-btn-text="
        selectedFilterParams.types[typeFilter.slugUrl]?.length
          ? $t('products.filters.clear')
          : ''
      "
      @clear="clearTypeSelection(typeFilter.slugUrl)"
    >
      <template #slider-modal-trigger-btn>
        <SliderModalNavBtn
          :btn-title="typeFilter['name']"
          :btn-text="
            formatSelection(selectedFilterParams.types[typeFilter.slugUrl])
          "
        />
      </template>

      <template #slider-modal-content>
        <SliderModalItem
          v-for="(filterValue, index) in typeFilter.filterValues"
          :key="filterValue['id']"
        >
          <UiCheckbox
            :id="filterValue['id']"
            v-model="selectedFilterParams.types[typeFilter.slugUrl]"
            class="body-m"
            :label="filterValue['value']"
            :label-position="LabelPositionOpts.LEFT"
            :native-value="filterValue['slugUrl']"
            @update:model-value="
              onFilterUpdate($event, filterValue, index, typeFilter)
            "
          />
        </SliderModalItem>
      </template>
    </SliderModalContainer>
  </SliderModalItem>
</template>

<script lang="ts" setup>
import type {
  FilterValues,
  TypeFilters,
} from '~/types/api/data/product/filter/filter.types'
import SliderModalContainer from './slider-modal-container.vue'
import SliderModalItem from './slider-modal-item.vue'
import SliderModalNavBtn from './slider-modal-nav-btn.vue'
import UiCheckbox, { LabelPositionOpts } from '@sephora-asia/ui-checkbox'
import useFilterTrackingEvent from '~/composables/utils/product-listing/filter/use-product-listing-filter-tracking'

interface Props {
  typeFilters: TypeFilters[]
}
const props = defineProps<Props>()

const { selectedFilterParams, clearTypeSelection } =
  useProductListingFiltersStore()

const { trackFilterClicked } = useFilterTrackingEvent()

// Map type filter values's slugUrl to name
const valueSlugToName = computed(() => {
  return props.typeFilters.reduce(
    (obj: { [key: string]: string }, filterType) => {
      filterType.filterValues.forEach(filterValue => {
        obj[filterValue.slugUrl] = filterValue.value
      })
      return obj
    },
    {}
  )
})

function formatSelection(selection: string[]) {
  if (!selection || !selection.length) return
  return selection.map(slug => valueSlugToName.value[slug]).join(', ')
}

function onFilterUpdate(
  event: string[],
  filterValue: FilterValues,
  index: number,
  typeFilter: TypeFilters
) {
  trackFilterClicked(event, {
    value: filterValue.slugUrl,
    slugUrl: filterValue.slugUrl,
    filterIndex: index,
    filterCategoryIndex: 1,
    type: typeFilter.slugUrl,
  })
}
</script>

<style lang="scss" scoped>
// For UiCheckbox label
label {
  width: inherit;
  height: inherit;
  align-items: center;
}
</style>
